import { Component, Inject } from '@angular/core'
import { DIALOG_DATA, DialogRef } from '@angular/cdk/dialog'
import { GenericConfirmationDialogModel } from './generic-confirmation-dialog.model'

@Component({
    selector: 'app-generic-confirmation-dialog',
    templateUrl: './generic-confirmation-dialog.component.html',
    styleUrls: ['./generic-confirmation-dialog.component.scss'],
})
export class GenericConfirmationDialogComponent {
    constructor(
        private readonly dialogRef: DialogRef<boolean>,
        @Inject(DIALOG_DATA) readonly data: GenericConfirmationDialogModel
    ) {}

    onConfirm(): void {
        this.dialogRef.close(true)
    }

    onCancel(): void {
        this.dialogRef.close(false)
    }
}
